<template>
  <div class="app flex-row align-items-center" id="forgot-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h3 class="text-center">Quên mật khẩu</h3>
                <b-alert
                  variant="danger"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlert"
                  @dismissed="mData.dataDefault.showDismissibleAlert=false"
                  style="white-space: pre-wrap;"
                >{{mData.dataDefault.error}}</b-alert>
                <b-alert
                  variant="success"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlertSuccess"
                  @dismissed="mData.dataDefault.showDismissibleAlertSuccess=false"
                >{{mData.dataDefault.success}}</b-alert>


                <el-form
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  ref="myForm"
                  label-width="100%"
                  label-position="top"
                  @submit.native.prevent
                >
                  <el-form-item label="Nhập Tài khoản/Email để lấy lại mật khẩu" prop="account">
                    <el-input
                      prefix-icon="el-icon-user"
                      v-model.trim="mData.dataForm.account"
                      clearable
                    ></el-input>
                  </el-form-item>

                  <el-form-item class="text-center">
                    <el-button
                      v-loading="loading"
                      :disabled="loading"
                      element-loading-spinner="el-icon-loading"
                      class="ladda-button"
                      type="primary"
                      @click="fn_submitForm()"
                      v-ladda
                      native-type="submit"
                    >Gửi mã khôi phục</el-button>
                  </el-form-item>
                </el-form>
                <b-col md="12" class="text-center">
                  <b-link to="/auth/login">Quay lại trang đăng nhập</b-link>
                </b-col>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <el-dialog
      class="list_account"
      title="Chọn tài khoản bạn muốn lấy lại mật khẩu"
      :visible.sync="haveManyAccounts"
      width="600px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div>
        <!-- <el-form ref="form" :model="form" :rules="" label-width="80px"> -->
          <el-radio-group v-model="mData.accountChooseFromDialog">
            <b-row>
              <b-col md="12" v-for="(item,index) in mData.listAccount" :key="index">
                <el-radio :label="item.Account">{{item.Account}} - {{item.Ho_ten}}</el-radio>
              </b-col>
            </b-row>
          </el-radio-group>
        <!-- </el-form> -->

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fn_revoerPassword(mData.accountChooseFromDialog)">Chọn</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import AccountApi from '../../moduleApi/AccountApi';
import * as Ladda from 'ladda';

export default {
  data() {
    return {
      loading: false,
      haveManyAccounts: false,
      aLang: LanguageService.lang,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
          success: "",
          showDismissibleAlertSuccess: false
        },
        dataForm: {
          account: ""
        },
        validForm: {
          account: [ValidService.required]
        },
        accountChooseFromDialog: "",
        listAccount: [],
      }
    };
  },
  methods: {
    fn_submitForm() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          const mailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          let isMail = mailRegex.test(this.mData.dataForm.account.toLowerCase());
          if(isMail === true){
            let data = {
              email: this.mData.dataForm.account
            }
            try {
              const res = await AccountApi.getAccountByEmail(data);
              if (res.result && res.result.length > 0){
                this.mData.dataDefault.showDismissibleAlert = false;
                if (res.result.length == 1) {
                  let account = res.result[0].Account;
                  this.fn_revoerPassword(account);
                } else if (res.result.length > 1){
                  this.haveManyAccounts = true;
                  this.mData.listAccount = res.result;
                }
              } else {
                this.showMessageError()
              }
            } catch (error) {
              this.showMessageError()
            }
          }else if(isMail === false){
            this.fn_revoerPassword(this.mData.dataForm.account);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    showMessageError() {
      MethodService.stopLadda()
      this.mData.dataDefault.showDismissibleAlert = true;
      this.mData.dataDefault.error =
      `Yêu cầu gửi mã khôi phục không thành công! Có thể do một trong các lý do sau:
      - Email chưa được đăng ký.
      - Tài khoản đã bị khóa.
      - Hoặc do đường truyền internet của bạn đang bị gián đoạn.`;
    },
    fn_revoerPassword(account){
      if(account == ""){
        window.toastr.error("Vui lòng chọn tài khoản!");
        return
      }
      this.loading = true;
      AuthService.recoverPassword(account)
      .then(res => {
        this.$router.push({
          name: "Auth-ResetPassword",
          query: { account: account },
          params: {
            msg: res.result && res.result.msg ? res.result.msg : null
          }
        });
        this.haveManyAccounts = false;
      })
      .catch(error => {
        this.mData.dataDefault.showDismissibleAlert = true;
        this.mData.dataDefault.error =
        `Yêu cầu gửi mã khôi phục không thành công! Có thể do một trong các lý do sau:
        - Tài khoản chưa được đăng ký.
        - Tài khoản đã bị khóa.
        - Tài khoản khai báo thiếu thông tin email và số điện thoại.
        - Hoặc do đường truyền internet của bạn đang bị gián đoạn.`;
      });
      this.loading = false
      this.haveManyAccounts = false;
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    }
  },
  mounted: function() {}
};
</script>
<style scoped>
  ::v-deep .list_account .el-dialog {
    margin-top: 20vh !important;
  }
  ::v-deep .list_account .el-dialog .el-dialog__body{
    padding: 15px;
  }

  ::v-deep .list_account .el-radio, ::v-deep .list_account .el-radio__input {
    white-space: normal;
    word-break: initial;
  }
  ::v-deep .el-loading-spinner{
    top: 30%;
    margin-top: 0px;
  }
  ::v-deep .el-button--small{
    padding: 10px 15px;
  }
  ::v-deep .el-button--primary{
    border: transparent;
  }
  ::v-deep .list_account .el-dialog .el-dialog__title{
    padding-right: 20px;
    display: block;
  }

  @media (min-width: 500px ) and (max-width: 768px) {
    ::v-deep .list_account .el-dialog{
      width: 400px !important;
    }
  }
  @media (max-width: 499px) {
    ::v-deep .list_account .el-dialog{
      width: 300px !important;
    }
  }
</style>
